<template>
  <div class="personalCenter">
    <div>
      <div class="partOne">
        <div
          class="bgc"
          :style="{
            backgroundImage: `url(${require('../images/image-1.png')})`,
          }"
        >
          <div style="background:rgba(133,135,132,0.2);">
            <div class="img-1">
              <div class="block big">
                <div class="x-wrap x-ct m-main">
                  <div class="igt1">
                    <div class="igtl">
                      <div class="lm">
                        <img src="../images/new-1.png" alt="" />
                      </div>
                      <div class="ls">
                        <span v-if="isMine"
                          >您好{{ nameContent }}，欢迎来到个人中心</span
                        >
                        <span v-else>您好，欢迎来到个人中心</span>
                        <!-- <span>上次登陆时间：2021.04.08 10:28:00{{time}}</span> -->
                      </div>
                    </div>
                    <div class="igtr">
                      <a href="javascript:void(0);"
                        ><div class="tc" @click="exitOut">退出</div></a
                      >
                      <!-- <a href=""><div class="xg">修改密码</div></a> -->
                      <router-link to="/personalCenter/modifyPassword" rel=""
                        ><div class="xg">修改密码</div>
                      </router-link>
                    </div>
                  </div>
                  <div class="igt2">
                    <div
                      class="igt2t"
                      :style="{
                        backgroundImage: `url(${require('../images/new-2.png')})`,
                      }"
                    >
                      <span>客户基本信息</span>
                    </div>
                    <div class="igt2b">
                      <!-- <a href=""><input type="text" value="注册ID:132513213"/></a> -->
                      <a href="javascript:void(0)"
                        ><input
                          disabled="disabled"
                          style="cursor: default;"
                          type="text"
                          :value="phoneContent"
                      /></a>
                      <router-link to="" rel=""
                        ><input
                          disabled="disabled"
                          type="text"
                          value="我的优惠券"
                        />
                      </router-link>

                      <a href="javascript:void(0)"
                        ><input
                          disabled="disabled"
                          style="cursor: default;"
                          type="text"
                          :value="myIndex"
                      /></a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="partTwo">
        <div class="m-main">
          <div class="tit tit-1">
            <router-link to="/medicalCenter/websiteBook" rel="">
              <span
                class="s1 s11 s1-1"
                :style="{
                  backgroundImage: `url(${require('../images/hz.png')})`,
                }"
              >门诊预约</span>
            </router-link>
            <router-link to="/medicalCenter/medicalPlan" rel=""
              ><span
                class="s12 s1-1"
                :style="{
                  backgroundImage: `url(${require('../images/tj.png')})`,
                  marginLeft:'5px'
                }"
                >体检预约</span
              >
            </router-link>
            <!-- <div v-if="hasPatient" class="selectBox">
                <a-select class="select" :default-value="activeOutpatient"  @change="selectChange">
                  <a-select-option :value="item.hisId" v-for="(item, index) in outpatientList" :key="item.name + index">
                    {{item.name}}
                  </a-select-option>
                </a-select>
              </div> -->
            <span v-if="radioValue == 1" class="s3 s31" id="link1">
              <router-link to="/personalCenter/personalList" rel=""
                ><div class="xg">查看更多</div>
              </router-link>
            </span>
            <span v-if="radioValue == 2" class="s3 s31" id="link2">
              <router-link to="/personalCenter/personalList" rel=""
                ><div class="xg">查看更多</div>
              </router-link>
            </span>
            <span class="box">
              <span
                v-if="radioValue == 1"
                class="a1 s1 s11 s11-1 s1-1"
                :style="{
                  backgroundImage: `url(${require('../images/hz1.png')})`,
                }"
                @click="btnClick1"
                >门诊预约记录</span
              >
              <span
                v-if="radioValue == 2"
                class="a1 s1 s11 s1-1"
                :style="{
                  backgroundImage: `url(${require('../images/hz.png')})`,
                }"
                @click="btnClick1"
                >门诊预约记录</span
              >
              <span
                v-if="radioValue == 1"
                class="a2 s12 s1-1"
                :style="{
                  backgroundImage: `url(${require('../images/tj.png')})`,
                  marginLeft:'5px'
                }"
                @click="btnClick2"
                >体检预约记录</span
              >
              <span
                v-if="radioValue == 2"
                class="a2 s12 s1-1 s11-1"
                :style="{
                  backgroundImage: `url(${require('../images/tj1.png')})`,
                }"
                @click="btnClick2"
                >体检预约记录</span
              >
            </span>
          </div>

          <div v-if="isMine == true">
            <div class="mobileTable" v-if="SCREEN.mobile">
              <div v-if="radioValue == 1">
                <div
                  class="tableData"
                  v-for="(item, index) in outpatientTableData"
                  :key="index"
                >
                  <div class="item">
                    <div class="left">就诊科室：</div>
                    <div class="right">{{ item.hisDeptName }}</div>
                  </div>
                  <div class="item">
                    <div class="left">医师：</div>
                    <div class="right">{{ item.hisDoctorName }}</div>
                  </div>
                  <div class="item">
                    <div class="left">预约时间：</div>
                    <div class="right">{{ item.orderTime }}</div>
                  </div>
                  <div class="item">
                    <div class="left">状态：</div>
                    <div class="right" v-if="item.payStatus == 0">
                      <span class="blue">预约成功</span>
                      <span>|</span>
                      <span>
                        <a class="red" @click="cancelOutpatientBook(item)"
                          >取消预约</a
                        >
                      </span>
                      <span>|</span>
                      <span>
                        <a class="red" @click="goPaymentPhone(item)">去付款</a>
                      </span>
                    </div>
                    <div class="right" v-if="item.payStatus == 1">
                      <span class="blue">支付成功</span>
                      <span>|</span>
                      <span>
                        <a class="red" @click="goRefund(item)">退号</a>
                      </span>
                    </div>
                    <div class="right" v-if="item.payStatus == 2">
                      <span>已取消</span>
                    </div>
                    <div class="right" v-if="item.payStatus == 3">
                      <span>已退号</span>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="radioValue == 2">
                <div
                  class="tableData"
                  v-for="(item, index) in examTableData"
                  :key="index"
                >
                  <div class="item">
                    <div class="left">体检套餐：</div>
                    <div class="right">
                      <div
                        v-for="(item1, index1) in item.packageInfoList"
                        :key="index1"
                      >
                        {{ item1.packageName }}
                      </div>
                    </div>
                  </div>
                  <div class="item">
                    <div class="left">预约体检时间：</div>
                    <div class="right">{{ item.reserveDate }}</div>
                  </div>
                  <div class="item">
                    <div class="left">状态：</div>
                    <div class="right">
                      <span v-if="item.payStatus == 1">
                        <span>
                          <a class="red" @click="cancelExamBook(item)"
                            >取消预约</a
                          >
                        </span>
                        <span>|</span>
                        <span>
                          <a @click="goExamPaymentPhone(item)">去付款</a>
                        </span>
                      </span>
                      <span
                        v-if="item.payStatus == 2 && item.reserveStatus == 1"
                      >
                        <span>
                          <a class="red" @click="goExamRefund(item)">退号</a>
                        </span>
                      </span>
                      <span
                        v-if="item.payStatus == 2 && item.reserveStatus == 2"
                      >
                        <span>登记</span>
                      </span>
                      <span
                        v-if="item.payStatus == 2 && item.reserveStatus == 3"
                      >
                        <span>检查</span>
                      </span>
                      <span
                        v-if="
                          (item.payStatus == 2 && item.reserveStatus == 4) ||
                            item.payStatus == 3 || item.payStatus == 4
                        "
                      >
                        <span>
                          <a @click="makeAppointment(item)">重新预约</a>
                        </span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="more" v-if="total > pageSize">
                <div class="btn" @click="viewMoreMobile()">查看更多</div>
              </div>
            </div>

            <div class="tableArea" v-else>
              <div v-if="radioValue == 1">
                <div class="tablebox">
                  <a-table
                    :columns="outpatientColumns"
                    :data-source="outpatientTableData"
                  >
                    <template slot="action" slot-scope="text, record">
                      <span v-if="record.payStatus == 0">
                        <span class="blue">预约成功</span>
                        <span>|</span>
                        <span>
                          <a class="red" @click="cancelOutpatientBook(record)"
                            >取消预约</a
                          >
                        </span>
                        <span>|</span>
                        <span>
                          <a @click="goPayment(record)">去付款</a>
                        </span>
                      </span>
                      <span v-if="record.payStatus == 1">
                        <span class="blue">支付成功</span>
                        <span>|</span>
                        <span>
                          <a class="red" @click="goRefund(record)">退号</a>
                        </span>
                      </span>
                      <span v-if="record.payStatus == 2">
                        <span>已取消</span>
                      </span>
                      <span v-if="record.payStatus == 3">
                        <span>已退号</span>
                      </span>
                    </template>
                  </a-table>
                </div>
                <div class="pagination" v-if="total > pageSize">
                  <a-pagination
                    :total="total"
                    @change="pageChange"
                    :pageSize="pageSize"
                    :current="page"
                  />
                </div>
              </div>
              <div v-if="radioValue == 2">
                <div class="tablebox">
                  <a-table :columns="examColumns" :data-source="examTableData">
                    <template slot="package" slot-scope="text, record">
                      <div
                        v-for="(item, index) in record.packageInfoList"
                        :key="index"
                      >
                        {{ item.packageName }}
                      </div>
                    </template>
                    <template slot="action" slot-scope="text, record">
                      <span v-if="record.payStatus == 1">
                        <span>
                          <a class="red" @click="cancelExamBook(record)"
                            >取消预约</a
                          >
                        </span>
                        <span>|</span>
                        <span>
                          <a @click="goExamPayment(record)">去付款</a>
                        </span>
                      </span>
                      <span
                        v-if="
                          record.payStatus == 2 && record.reserveStatus == 1
                        "
                      >
                        <span>
                          <a class="red" @click="goExamRefund(record)">退号</a>
                        </span>
                      </span>
                      <span
                        v-if="
                          record.payStatus == 2 && record.reserveStatus == 2
                        "
                      >
                        <span>登记</span>
                      </span>
                      <span
                        v-if="
                          record.payStatus == 2 && record.reserveStatus == 3
                        "
                      >
                        <span>检查</span>
                      </span>
                      <span
                        v-if="
                          (record.payStatus == 2 &&
                            record.reserveStatus == 4) ||
                            record.payStatus == 3 || record.payStatus == 4
                        "
                      >
                        <span>
                          <a @click="makeAppointment(record)">重新预约</a>
                        </span>
                      </span>
                    </template>
                    <!-- <span slot="action" slot-scope="text, record">
                    <a
                      slot="action"
                      href="javascript:;"
                      @click="viewMoreDetailPC(record)"
                      >查看详细</a
                    >
                  </span> -->
                  </a-table>
                </div>
                <div class="pagination" v-if="total > pageSize">
                  <a-pagination
                    :total="total"
                    @change="pageChange"
                    :pageSize="pageSize"
                    :current="page"
                  />
                </div>
              </div>
            </div>
          </div>

          <div v-else class="noData">
            本人暂无预约记录，请到个人中心查询其他就诊人相关信息
          </div>
        </div>
      </div>

      <div class="partThree">
        <div
          class="x-container co"
          :style="{
            backgroundImage: `url(${require('../images/bgh.jpg')})`,
          }"
        >
          <div class="x-wrap xa m-main">
            <div
              class="im-g"
              :style="{
                backgroundImage: `url(${require('../images/bh1.jpg')})`,
              }"
            ></div>
            <router-link to="/personalCenter/personalList#6" rel="">
              <div class="yt">
                <img class="im1" src="../images/ig-1.png" alt="" /><br />
                <img src="../images/heng.jpg" alt="" /><br /><span
                  >报告查询</span
                >
              </div>
            </router-link>
            <div
              class="im-g"
              :style="{
                backgroundImage: `url(${require('../images/bh2.jpg')})`,
              }"
            ></div>
            <router-link to="/personalCenter/personalList#3" rel="">
              <div class="yt">
                <img class="im1" src="../images/ig-2.png" alt="" /><br />
                <img src="../images/heng.jpg" alt="" /><br /><span
                  >就诊人信息</span
                >
              </div>
            </router-link>
            <router-link to="" rel="">
              <div
                class="yt"
                style="border-top:5px solid #86c1f2;border-bottom:0;"
              >
                <img
                  class="im1"
                  style="margin-top:37px;"
                  src="../images/ig-3.png"
                  alt=""
                /><br />
                <img src="../images/heng.jpg" alt="" /><br /><span
                  >会员权益</span
                >
              </div>
            </router-link>
            <div
              class="im-g"
              :style="{
                backgroundImage: `url(${require('../images/bh3.jpg')})`,
              }"
            ></div>
            <router-link to="/personalCenter/personalList#7" rel="">
              <div class="yt">
                <img class="im1" src="../images/ig-4.png" alt="" /><br />
                <img src="../images/heng.jpg" alt="" /><br /><span
                  >消费明细</span
                >
              </div>
            </router-link>
            <div
              class="im-g"
              :style="{
                backgroundImage: `url(${require('../images/bh4.jpg')})`,
              }"
            ></div>
          </div>
        </div>
      </div>
    </div>
    <!-- 支付弹框 -->
    <!-- <div v-show="paymentVisible">
      <div class="wemsk"></div>
      <div class="ewmboxfix">
        <div class="closeBtn" @click="closePaymentModal">X</div>
        <div class="payInfo">
          <div class="left">
          <div v-if="radioValue==1" class="main">
            {{
              "您预约" + paymentRecord.hisDeptName + paymentRecord.hisDoctorName + "医生" + paymentRecord.orderTime + "挂号成功"
            }}
          </div>
        </div>
        <div class="right">
          <div class="payable">应付金额：</div>
          <div v-if="radioValue==1" class="money">{{ paymentRecord.fee }}元</div>
        </div>
        </div>
        <div class="tipInfo">请用微信、支付宝扫码支付。请于30分钟内完成支付，如在有效期内未完成支付，将自动为您取消预约</div>
        <div id="qrcode" class="qrcodeBox"></div>
        <div class="detail">
          距离二维码过期还剩
          <span style="colorr: #F93E3E;" id="time">{{ num }} </span
          >秒，过期后请重新获取二维码
        </div>
      </div>
    </div> -->
    <!-- 支付弹框 -->
    <div v-show="paymentVisible">
      <div class="wemsk"></div>
      <div class="pay-model-box">
        <div class="pay-main-box">
          <div class="title">
            <div v-if="radioValue == 1" class="top-title">
              挂号成功<span class="close-span" @click="closePaymentModal"
                >x</span
              >
            </div>
            <div v-if="radioValue == 2" class="top-title">
              预约成功<span class="close-span" @click="closePaymentModal"
                >x</span
              >
            </div>
            <div v-if="radioValue == 1" class="two-box">
              您预约的{{
                paymentRecord.hisDeptName +
                  paymentRecord.hisDoctorName +
                  '医生'
              }}<span>{{ paymentRecord.orderTime }}</span
              >挂号成功
            </div>
            <div v-if="radioValue == 2" class="two-box">
              您预约的<span>{{ examBookTime }}</span
              >{{ examBooKMail }}预约成功
            </div>
            <div class="three-box">
              请于<span>30分钟</span>内完成支付，如在有效期内未完成支付，将自动为您取消预约
            </div>
          </div>
          <div class="pay-money">
            应付金额：<span>{{ paymentFee }}</span
            >元
          </div>
          <div class="img-box">
            <div class="left-img-box">
              <div class="qrcode-out-box">
                <div id="qrcode" class="qrcode-box"></div>
              </div>
              <div class="bottom-remind-box">
                <img class="img" src="../images/sm.png" alt="" />
                <div class="txt">请使用微信、支付宝<br />扫码支付</div>
              </div>
            </div>
            <div class="right-img-box">
              <img src="../images/payBg.png" alt="" />
            </div>
          </div>
          <div class="red-txt-box">
            <div class="content-red-box">
              <img src="../images/gth.png" alt="" />
              距离二维码过期还剩<span>{{ num }}</span
              >秒，过期后请重新获取二维码
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 支付成功弹框 -->
    <div v-if="paySuccessVisible">
      <div class="wemsk"></div>
      <!-- <div class="ewmboxfix paySucess">
        <div class="closeBtn" @click="closePaySuccessModal">X</div>
        <div class="successContent">
          支付成功
        </div>
        <div class="successMoney">
         ￥ {{ paymentRecord.fee }}
        </div>
        <div class="closeInfo">{{paySuccessNum}}秒后关闭</div>
      </div> -->
      <div class="pay-success-model-box">
        <div class="top-title">
          支付成功<span class="close-span" @click="closePaySuccessModal"
            >x</span
          >
        </div>
        <div class="middle-box">
          <img src="../images/success.png" alt="" />
          您已成功付款<span>{{ paymentFee }}</span
          >元
        </div>
        <div class="bottom-box">
          <span>{{ paySuccessNum }}</span
          >s后自动关闭
        </div>
      </div>
    </div>

    <!-- 手机支付中弹框 -->
    <div v-if="payPhoneVisible">
      <div class="wemsk"></div>
      <div class="pay-success-model-box">
        <div class="top-title">
          支付中<span class="close-span" @click="closePayPhoneModal">x</span>
        </div>
        <div class="middle-box">
          <!-- <img src="../images/success.png" alt=""> -->
          请于30分钟内完成支付，如在有效期内未完成支付，将自动为您取消预约
        </div>
        <div class="bottom-box">
          <span>{{ num }}</span
          >s后自动关闭，请重新获取支付链接
        </div>
      </div>
    </div>

    <!-- 是否支付完成弹窗begin -->
    <div v-if="showHasPaySuccess">
      <div class="wemsk"></div>
      <div class="has-pay-success">
        <div class="gth-box">
          <div class="gth">
            !
          </div>
        </div>
        <div class="txt">请确认是否支付完成</div>
        <div class="btn-box">
          <p @click="refreshPay">重新支付</p>
          <p class="red-btn" @click="hasPaySuccess">已完成支付</p>
        </div>
      </div>
    </div>
    <!-- 是否支付完成弹窗end -->
  </div>
</template>
<script>
import{ encryptByDES } from '@/utils/index';
import { JSEncrypt } from "jsencrypt";
export default {
  name: 'hospital-personal-center-001',
  data() {
    return Object.assign({
      publicKey: '',
      nameContent: '',
      phoneContent: '手机号:',
      myIndex: '本人主索引:',
      radioValue: 1,
      total: 0,
      pageSize: 9,
      page: 1,
      outpatientColumns: [
        {
          title: '就诊科室',
          dataIndex: 'hisDeptName',
          key: 'hisDeptName',
        },
        {
          title: '医师',
          dataIndex: 'hisDoctorName',
          key: 'hisDoctorName',
        },
        {
          title: '预约时间',
          dataIndex: 'orderTime',
          key: 'orderTime',
        },
        {
          title: '状态',
          scopedSlots: {
            customRender: 'action',
          },
        },
      ],
      outpatientTableData: [
        // {
        //   hisDeptName: "儿科",
        //   hisDoctorName: "张三",
        //   type: "专科门诊",
        //   orderTime: "2021-5-2",
        // }
      ],

      examColumns: [
        {
          title: '体检套餐',
          scopedSlots: {
            customRender: 'package',
          },
        },
        {
          title: '预约体检时间',
          dataIndex: 'reserveDate',
          key: 'reserveDate',
        },
        {
          title: '状态',
          scopedSlots: {
            customRender: 'action',
          },
        },
      ],
      examTableData: [
        // {
        //   department: "儿科",
        //   doctor: "张三",
        //   type: "专科门诊",
        //   appointment: "2021-5-2",
        // }
      ],

      hospitalCode: 'H05',

      hisPatientId: null,

      // activeOutpatient: '',
      outpatientList: [
        {
          name: '测试人',
        },
      ],

      hasPatient: false, //是否有就诊人
      isMine: false, //就诊人是否是本人
      mineInfo: {}, //本人的信息

      paymentVisible: false, // 显示支付弹框
      paymentQrCode: '', // 二维码显示链接
      paymentRecord: {
        // 支付数据信息
        // hisDeptName: "",
        // hisDoctorName: "",
        // orderTime: "",
        // fee: "",
      },
      timer: '', // 定时器
      num: 60, // 二维码展示倒计时时长

      paySuccessTimer: '', // 支付成功计时器
      paySuccessNum: 5, // 支付成功展示时间
      paySuccessVisible: false, // 显示支付成功

      paymentFee: '', // 支付金额
      examBooKMail: '', // 体检预约套餐
      examBookTime: '', // 体检预约时间

      payPhoneVisible: false, // 手机支付弹框显示

      showHasPaySuccess: false, // 手机支付中弹框

      paymentLock: true, // 手机支付锁，防止多次点击去支付
    })
  },

  created() {
    this.getPublicKey();
  },
  mounted() {
    let ut = localStorage.getItem('ut')
    // localStorage中没有ut，判断是否登录
    const LoginStatus = ut == undefined || ut == null || ut == 'undefined' || ut == 'null' || ut == ''
    if (LoginStatus) {
      this.$router.push({
        path: '/personalCenter/login',
        query: { redirect: '/personalCenter/personalInfomation' }, // 将跳转的路由path作为参数，登录成功后跳转到该路由
      })
      return
    }
    this.getPatientList()
  },
  methods: {
    // 退出登录
    exitOut() {
      localStorage.removeItem('userId')
      localStorage.removeItem('ut')
      let ut = localStorage.getItem('ut')
      let userId = localStorage.getItem('userId')
      // 跳转登录页
      console.log('logout localStorage ut:', ut)
      console.log('logout localStorage userId:', userId)
      
      this.$router.push('/personalCenter/login')
    },
    pageChange(page, pageSize) {
      this.page = page
      this.pageSize = pageSize
      this.radioValueChange()
    },
    // radioValueChange() {
    //   if (this.radioValue == 1) {
    //     document.querySelector(".a1").className = "a1 s1 s11 s11-1 s1-1";
    //     document.querySelector(".a2").className = "a2 s12 s1-1";
    //   } else {
    //     document.querySelector(".a2").className = "a2 s12 s1-1 s11-1";
    //     document.querySelector(".a1").className = "a1 s1 s11 s1-1";
    //   }
    //   this.getTableList();
    // },
    // selectChange(value){
    //   console.log("select value:",value)
    //   console.log("radioValue:",this.radioValue)
    //   this.hisPatientId = value;
    //   if(this.radioValue == 1){
    //     this.btnClick1();
    //   }
    //   if(this.radioValue == 2){
    //     this.btnClick2();
    //   }
    // },
    btnClick1() {
      // this.paymentVisible = true;
      // this.getQrCode();
      // this.openPaySuccessModal();
      // this.openPayPhoneModal();
      this.radioValue = 1
      this.pageSize = 9
      this.page = 1
      if (this.isMine) {
        this.getOutpatientTableList()
      }
    },
    btnClick2() {
      this.radioValue = 2
      this.pageSize = 9
      this.page = 1
      if (this.isMine) {
        this.getExamTableList()
      }
    },
    viewMoreMobile() {
      //请求几条？
      console.log('手机查看更多')
      this.pageSize = this.total
      if (this.radioValue == 1) {
        this.getOutpatientTableList()
      } else if (this.radioValue == 2) {
        this.getExamTableList()
      }
    },
    // viewMoreDetailMobile(index) {
    //   console.log("index");
    //   this.getExamTableList(newsData[index].id);
    // },

    // 体检预约记录-重新预约
    makeAppointment() {
      // 跳转页面
      this.$router.push('/medicalCenter/medicalPlan')
    },
    // 获取就诊人列表
    getPatientList() {
      this.$API
        .patientList({
          hospitalCode: this.hospitalCode,
        })
        .then((res) => {
          console.log('getPatientList:', res)
          if (res) {
            this.outpatientList = res.data
            if (res.data.length != 0) {
              this.hasPatient = true
              // this.activeOutpatient = this.outpatientList[0].name;
            }
            for (let i = 0; i < this.outpatientList.length; i++) {
              if (this.outpatientList[i].relationshipCode == '0') {
                this.isMine = true
                this.mineInfo = this.outpatientList[i]
                this.hisPatientId = this.outpatientList[i].hisId
                this.phoneContent = this.phoneContent + (this.mineInfo.phoneHide || '')
                this.myIndex = this.myIndex + this.mineInfo.cardNo
                if (this.mineInfo.gender == '1') {
                  this.nameContent = this.mineInfo.name + '先生'
                } else {
                  this.nameContent = this.mineInfo.name + '女士'
                }
              }
            }
            if (this.isMine) {
              this.btnClick1()
            }
          }
        })
    },
    getPublicKey() {
      this.$API.rsaPublic().then((res) => {
        if (res.code == 0) {
          this.publicKey = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 加密
    setEncrypt(msg) {
      let jsencrypt = new JSEncrypt({});
      jsencrypt.setPublicKey(this.publicKey);
      return jsencrypt.encrypt(msg);
    },
    // 获取门诊预约列表
    getOutpatientTableList() {
      // const enDes = encryptByDES(this.hisPatientId, '6519625babf183f8')
      // const encodeEnDes = window.encodeURIComponent(enDes)
      const hisPatientId = this.setEncrypt(this.hisPatientId);
      const encodeEnAes = window.encodeURIComponent(hisPatientId);
      this.$API
        .getOutpatientBookList({
          hospitalCode: this.hospitalCode,
          hisPatientId: encodeEnAes,
          pageNo: this.page,
          pageSize: this.pageSize,
        })
        .then((res) => {
          this.total = res.data.total
          // this.$set(this, "outpatientTableData", res.data.list);
          this.outpatientTableData = res.data
        })
    },
    // 获取体检预约列表
    getExamTableList() {
      // const enDes = encryptByDES(this.hisPatientId, '6519625babf183f8')
      // const encodeEnDes = window.encodeURIComponent(enDes)
      const hisPatientId = this.setEncrypt(this.hisPatientId);
      const encodeEnDes = window.encodeURIComponent(hisPatientId);
      this.$API
        .getExamBookList({
          hospitalCode: this.hospitalCode,
          hisPatientId: encodeEnDes,
          pageNo: this.page,
          pageSize: this.pageSize,
        })
        .then((res) => {
          this.total = res.data.total
          // this.$set(this, "tableData", res.data.list);
          this.examTableData = res.data
        })
    },
    // 取消门诊预约
    cancelOutpatientBook(value) {
      let that = this
      this.$confirm({
        title: '提示',
        content: '确认取消预约？',
        okText: '确认',
        cancelText: '取消',
        onOk() {
          that.$API
            .bookCancel({
              hospitalCode: that.hospitalCode,
              orderCode: value.orderCode,
            })
            .then((res) => {
              if (res && res.code == 0) {
                that.getOutpatientTableList()
              }
            })
        },
        onCancel() {},
      })
    },
    // 门诊退号
    goRefund(value) {
      let that = this
      this.$confirm({
        title: '提示',
        content: '确认退号？',
        okText: '确认',
        cancelText: '取消',
        onOk() {
          that.$API
            .bookRefund({
              hospitalCode: 'H05',
              orderCode: value.orderCode,
              visitId: value.visitId,
            })
            .then((res) => {
              if (res && res.code == 0) {
                that.getOutpatientTableList()
              }
            })
        },
        onCancel() {},
      })
    },
    // 体检退号
    goExamRefund(value) {
      let that = this
      this.$confirm({
        title: '提示',
        content: '确认退号？',
        okText: '确认',
        cancelText: '取消',
        onOk() {
          that.$API
            .examRefund({
              hospitalCode: that.hospitalCode,
              reserveNetId: value.reserveId,
              packageCode: value.packageInfoList[0].packageCode,
            })
            .then((res) => {
              if (res && res.code == 0) {
                that.getExamTableList()
              }
            })
        },
        onCancel() {},
      })
    },
    // 取消体检预约
    cancelExamBook(value) {
      let that = this
      this.$confirm({
        title: '提示',
        content: '确认取消预约？',
        okText: '确认',
        cancelText: '取消',
        onOk() {
          that.$API
            .cancelExamBook({
              hospitalCode: that.hospitalCode,
              reserveId: value.reserveId,
              hisPatientId: value.hisPatientId,
            })
            .then((res) => {
              if (res && res.code == 0) {
                that.getExamTableList()
              }
            })
        },
        onCancel() {},
      })
    },

    // 门诊去付款
    goPayment(record) {
      if ((this.paymentLock = false)) {
        return
      }
      if ((this.paymentLock = true)) {
        this.paymentLock = false
      }
      let orderCode = record.orderCode
      let hisPatientId = record.hisPatientId
      let fee = record.fee * 100 // 按分计算，返回值乘以100为元
      this.paymentRecord = record
      this.paymentFee = record.fee
      let data = {
        sys: 'H05',
        source: 'website',
        platform: 'ZN',
        payType: 'qrcode',
        businessId: 'A1',
        businessType: '预约支付',
        productId: orderCode,
        productName: '门诊预约',
        totalFee: fee, // 按分计算，返回值乘以100为元
        buyerId: hisPatientId,
        accessType: 10,
      }
      this.$API.goPay(data).then((res) => {
        console.log('goPay res:', res)
        this.paymentLock = true
        if (res && res.code == '0') {
          this.paymentQrCode = res.data
          this.paymentVisible = true
          document.getElementsByClassName('personalCenter')[0].style.position =
            'relative'
          document.getElementsByClassName(
            'personalCenter'
          )[0].style.zIndex = 1000
          this.getQrCode()
        }
      })
    },

    // 生成支付二维码
    getQrCode() {
      this.timer = setInterval(this.clock, 1000)
      let that = this
      // this.paymentQrCode="https://qr.95516.com/01020001/wcqr?f=ICBCqr&X=1&T=3&P=13&I=e03d925776684b4d&N=eda2cd4a81a690c8a44f6a1288309c1b&L=0fe51c864aef965d696f79225b4a271785d4670d20ce2e676a7e89b9a1d132589704dc03df521bc68c70ba61e2622fa2"
      console.log('this inside qrcode:', that.paymentQrCode)
      let qrcode = require('qrcodejs2')
      document.getElementById('qrcode').innerHTML = ''
      new qrcode(document.getElementById('qrcode'), {
        text: that.paymentQrCode,
        width: 183,
        height: 183,
        correctLevel: qrcode.CorrectLevel.Q,
      })
    },
    // 计时器
    clock() {
      if (this.num > 0) {
        if (this.radioValue == 1) {
          this.checkPaymentStatus() // 检查门诊预约支付状态
        }
        if (this.radioValue == 2) {
          this.checkExamPaymentStatus() // 检查体检预约支付状态
        }
        this.num--
      } else {
        // this.closePaymentModal();
        this.num = 60
        clearInterval(this.timer)
        if (this.radioValue == 1) {
          this.goPayment() // 检查门诊预约支付状态
        }
        if (this.radioValue == 2) {
          this.goExamPayment() // 检查体检预约支付状态
        }
      }
    },
    // 查询门诊支付状态
    checkPaymentStatus() {
      let data = {
        hospitalCode: this.hospitalCode,
        hisPatientId: this.paymentRecord.hisPatientId,
        orderCode: this.paymentRecord.orderCode,
      }
      this.$API.checkPaymentStatus(data).then(
        (res) => {
          console.log('checkPaymentStatus res:', res)
          if (res && res.code == '0') {
            if (res.data == 'P') {
              this.getOutpatientTableList()
              if (this.SCREEN.mobile) {
                this.closePayPhoneModal() // 关闭手机端
              } else {
                this.closePaymentModal() // 关闭PC端
              }
              this.openPaySuccessModal()
            }
          }
        },
        (error) => {
          console.log('checkPaymentStatus error:', error)
          if (this.SCREEN.mobile) {
            this.closePayPhoneModal()
          } else {
            this.closePaymentModal()
          }
        }
      )
    },

    // 检查体检预约支付状态
    checkExamPaymentStatus() {
      // hisPatientId
      // const enDes = encryptByDES(this.paymentRecord.hisPatientId, '6519625babf183f8')
      // const encodeEnDes = window.encodeURIComponent(enDes)
      const hisPatientId = this.setEncrypt(this.paymentRecord.hisPatientId);
      const encodeEnDes = window.encodeURIComponent(hisPatientId);
      // idNo
      // const idNoEnDes = encryptByDES(this.mineInfo.idNo, '6519625babf183f8')
      const idNoEnDes = this.mineInfo.idNo
      const idNoEncodeEnDes = window.encodeURIComponent(idNoEnDes)
      let data = {
        hospitalCode: this.hospitalCode,
        hisPatientId: encodeEnDes,
        idNo: idNoEncodeEnDes,
        idType: this.mineInfo.idType,
        reserveNetId: this.paymentRecord.reserveId,
      }
      this.$API.checkExamPaymentStatus(data).then(
        (res) => {
          console.log('checkExamPayStatus res:', res)
          if (res && res.code == '0') {
            if (res.data == '2') {
              this.getExamTableList()
              if (this.SCREEN.mobile) {
                this.closePayPhoneModal()
              } else {
                this.closePaymentModal()
              }
              this.openPaySuccessModal()
            }
          }
        },
        (error) => {
          console.log('checkExamPaymentStatus error:', error)
          if (this.SCREEN.mobile) {
            this.closePayPhoneModal()
          } else {
            this.closePaymentModal()
          }
        }
      )
    },

    // 关闭支付弹窗
    closePaymentModal() {
      this.paymentVisible = false
      document.getElementsByClassName('personalCenter')[0].style.position =
        'unset'
      document.getElementsByClassName('personalCenter')[0].style.zIndex = 5
      clearInterval(this.timer)
      this.num = 60
    },

    // 支付成功弹窗
    openPaySuccessModal() {
      this.paySuccessVisible = true
      document.getElementsByClassName('personalCenter')[0].style.position =
        'relative'
      document.getElementsByClassName('personalCenter')[0].style.zIndex = 1000
      // 支付成功计时器
      this.paySuccessTimer = setInterval(this.successClock, 1000)
    },
    // 支付成功计时器
    successClock() {
      if (this.paySuccessNum > 0) {
        this.paySuccessNum--
      } else {
        this.closePaySuccessModal()
      }
    },
    // 关闭支付成功弹窗
    closePaySuccessModal() {
      this.paySuccessVisible = false
      document.getElementsByClassName('personalCenter')[0].style.position =
        'unset'
      document.getElementsByClassName('personalCenter')[0].style.zIndex = 5
      clearInterval(this.paySuccessTimer)
      this.paySuccessNum = 5
    },

    // 体检去付款
    goExamPayment(record) {
      if ((this.paymentLock = false)) {
        return
      }
      if ((this.paymentLock = true)) {
        this.paymentLock = false
      }
      let orderCode =
        record.reserveId + ',' + record.packageInfoList[0].packageCode
      let hisPatientId = record.hisPatientId
      let fee = record.packageInfoList[0].packagePrice * 100 // 按分计算，返回值乘以100为元
      this.paymentRecord = record
      this.paymentFee = record.packageInfoList[0].packagePrice
      this.examBooKMail = record.packageInfoList[0].packageName
      this.examBookTime = record.reserveDate
      let data = {
        sys: 'H05',
        source: 'website',
        platform: 'ZN',
        payType: 'qrcode',
        businessId: 'C1',
        businessType: '体检套餐支付',
        productId: orderCode,
        productName: '成都个人体检预约',
        totalFee: fee, // 按分计算，返回值乘以100为元
        buyerId: hisPatientId,
        accessType: 10,
      }
      this.$API.goPay(data).then((res) => {
        this.paymentLock = true
        console.log('goPay res:', res)
        if (res && res.code == '0') {
          this.paymentQrCode = res.data
          this.paymentVisible = true
          this.getQrCode()
        }
      })
    },

    // 门诊去付款手机端
    goPaymentPhone(record) {
      if ((this.paymentLock = false)) {
        return
      }
      if ((this.paymentLock = true)) {
        this.paymentLock = false
      }
      let orderCode = record.orderCode
      let hisPatientId = record.hisPatientId
      let fee = record.fee * 100 // 按分计算，返回值乘以100为元
      this.paymentRecord = record
      this.paymentFee = record.fee
      let data = {
        sys: 'H05',
        source: 'website',
        platform: 'ZN',
        payType: 'h5',
        businessId: 'A1',
        businessType: '预约支付',
        productId: orderCode,
        productName: '门诊预约',
        totalFee: fee, // 按分计算，返回值乘以100为元
        buyerId: hisPatientId,
        accessType: 10,
      }
      this.$API.goPayPhone(data).then((res) => {
        this.paymentLock = true
        console.log('goPayPhone res:', res)
        if (res && res.code == '0') {
          this.paymentQrCode = res.data
          // this.paymentVisible = true;
          // this.getQrCode();
          let u = navigator.userAgent
          let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 //android终端
          let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) //ios终端
          if (isAndroid) {
            //android终端
            window.open(this.paymentQrCode, '_blank')
          } else if (isiOS) {
            //ios终端
            window.location.href = this.paymentQrCode
          }
          this.openPayPhoneModal()
        }
      })
    },
    // 打开手机支付中弹框
    openPayPhoneModal() {
      // this.payPhoneVisible = true;
      // this.timer = setInterval(this.phoneClock, 1000);
      let timer = setTimeout(() => {
        this.showHasPaySuccess = true
        clearTimeout(timer)
      }, 3000)
    },

    // 手机计时器
    phoneClock() {
      if (this.num > 0) {
        if (this.radioValue == 1) {
          this.checkPaymentStatus() // 检查门诊预约支付状态
        }
        if (this.radioValue == 2) {
          this.checkExamPaymentStatus() // 检查体检预约支付状态
        }
        this.num--
      } else {
        this.closePayPhoneModal()
      }
    },
    // 关闭手机支付中弹框
    closePayPhoneModal() {
      this.payPhoneVisible = false
      clearInterval(this.timer)
      this.num = 60
    },

    // 体检手机端去付款
    goExamPaymentPhone(record) {
      if ((this.paymentLock = false)) {
        return
      }
      if ((this.paymentLock = true)) {
        this.paymentLock = false
      }
      let orderCode =
        record.reserveId + ',' + record.packageInfoList[0].packageCode
      let hisPatientId = record.hisPatientId
      let fee = record.packageInfoList[0].packagePrice * 100 // 按分计算，返回值乘以100为元
      this.paymentRecord = record
      this.paymentFee = record.packageInfoList[0].packagePrice
      this.examBooKMail = record.packageInfoList[0].packageName
      this.examBookTime = record.reserveDate
      let data = {
        sys: 'H05',
        source: 'website',
        platform: 'ZN',
        payType: 'h5',
        businessId: 'C1',
        businessType: '体检套餐支付',
        productId: orderCode,
        productName: '成都个人体检预约',
        totalFee: fee, // 按分计算，返回值乘以100为元
        buyerId: hisPatientId,
        accessType: 10,
      }
      this.$API.goPayPhone(data).then((res) => {
        this.paymentLock = true
        console.log('goPayPhone res:', res)
        if (res && res.code == '0') {
          this.paymentQrCode = res.data
          // this.paymentVisible = true;
          // this.getQrCode();
          let u = navigator.userAgent
          let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 //android终端
          let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) //ios终端
          if (isAndroid) {
            //android终端
            window.open(this.paymentQrCode, '_blank')
          } else if (isiOS) {
            //ios终端
            window.location.href = this.paymentQrCode
          }
          this.openPayPhoneModal()
        }
      })
    },

    // 已完成支付
    hasPaySuccess() {
      this.showHasPaySuccess = false
      if (this.radioValue == 1) {
        this.getOutpatientTableList() // 获取门诊列表
      }
      if (this.radioValue == 2) {
        this.getExamTableList() // 获取体检列表
      }
    },
    // 重新支付
    refreshPay() {
      if (this.radioValue == 1) {
        this.goPaymentPhone(this.paymentRecord) // 调用门诊支付接口
      }
      if (this.radioValue == 2) {
        this.goExamPaymentPhone(this.paymentRecord) // 调用体检支付接口
      }
    },
  },
}
</script>
<style lang="less" scoped>
.m-screen-mobile{
  .personalCenter{
  margin-left:-0.25rem;
  margin-right:-0.25rem;
}
}
.partOne {
  .bgc {
    background-size: 100% 100% !important;
    background: no-repeat;
    width: 100%;
    height: 378px;
    .img-1 {
      width: 100%;
      height: 378px;
      background-color: rgba(3, 52, 114, 0.4);
      .big {
        height: 82px;
        background: rgba(3, 65, 124, 0.1);
        .x-wrap {
          position: relative;
          // width: 1230px;
          height: 100%;
          margin: auto;
        }
        .igt1 {
          overflow: hidden;
          .igtl {
            width: auto;
            display: inline-block;
            height: 82px;
            line-height: 82px;
            overflow: hidden;
            float: left;
            .lm {
              width: 46px;
              height: 46px;
              border-radius: 50%;
              display: inline-block;
              background: #0078d4;
              float: left;
              margin-top: 18px;
              margin-right: 14px;
              text-align: center;
              line-height: 46px;
              img {
                width: 24px;
                height: 24px;
                vertical-align: middle;
                margin-top: 11px;
                margin-left: 11px;
              }
            }

            .ls {
              width: 700px;
            }
            span {
              font-size: 14px;
              color: #fff;
              margin-top: -18px;
              // margin-top: 10px;
            }
          }
          .igtr {
            line-height: 82px;
            float: right;
            .tc {
              display: inline-block;
              width: 100px;
              height: 34px;
              border-radius: 17px;
              border: 1px solid #fff;
              text-align: center;
              line-height: 34px;
              color: #fff;
              margin-left: 8px;
              font-size: 14px;
            }
            .xg {
              display: inline-block;
              width: 100px;
              height: 34px;
              border-radius: 17px;
              border: 1px solid #fff;
              text-align: center;
              line-height: 34px;
              color: #fff;
              margin-left: 8px;
              font-size: 14px;
            }
          }
        }
        .igt2 {
          width: 100%;
          height: auto;
          margin-top: 70px !important;
          .igt2t {
            width: 100%;
            height: 76px;
            background: no-repeat;
            padding-left: 106px;
            box-sizing: border-box;
            background-size: auto 100%;
            span {
              font-size: 30px;
              color: #fff;
              border-left: 1px solid #a7b4c5;
              height: 30px !important;
              display: inline-block;
              line-height: 30px;
              padding-left: 22px;
              margin-top: 23px;
            }
          }
          .igt2b {
            width: 100%;
            height: auto;
            margin-top: 24px;
            overflow: hidden;
            a {
              text-decoration: none;
              color: inherit;
              input {
                width: 20%;
                height: 32px;
                border: 1px solid #a7b4c5;
                float: left;
                border-radius: 16px;
                margin-right: 14px;
                text-align: center;
                line-height: 32px;
                color: #fff;
                font-size: 14px;
                cursor: pointer;
                background: none;
              }
            }
          }
        }
      }
    }
  }
}

.partTwo {
  padding-top: 100px;
  padding-bottom: 110px;
  .tit {
    font-size: 24px;
    color: #333333;
    padding-bottom: 14px;
    position: relative;
    // z-index: 2;
    .selectBox {
      display: inline-block;
    }
    .select {
      width: 150px;
    }
    /deep/ .ant-select .ant-select-selection--single {
      border-radius: 20px;
    }
    a {
      text-decoration: none;
      color: inherit;
    }
    span {
      display: inline-block;
    }
    .s3 {
      float: right;
      font-size: 14px;
      // color: #707070;
      // padding-top: 10px;
      a {
        width: 100%;
        height: 100%;
        display: block;
        text-decoration: none;
        color: inherit;
      }
    }
    .s31 {
      width: 105px !important;
      height: 34px;
      text-align: center;
      line-height: 34px !important;
      background: #0078d4;
      border-radius: 17px;
      color: #fff !important;
      padding: 0 !important;
      margin-top: 5px;
    }
    .box {
      float: right;
      margin-right: 30px;
      .s1-1 {
        width: 160px;
      }
    }
    .s11,
    .s12 {
      cursor: pointer;
      width: 110px;
      height: 42px;
      border: 1px solid #0078d4;
      border-radius: 21px;
      text-align: center;
      line-height: 42px !important;
      font-size: 14px;
      background: no-repeat left center;
      background-position: 10px;
      padding-left: 25px;
      box-sizing: border-box;
    }
    .s11-1 {
      color: #fff;
      background: #0078d4 no-repeat center left;
      background-position: 10px;
      padding-left: 25px;
      box-sizing: border-box;
    }
  }

  .noData {
    font-size: 16px;
    text-align: center;
    padding-top: 15px;
  }

  .tableArea {
    .tablebox {
      .blue {
        color: #3984e1;
      }
      .red {
        color: #de4747;
      }
    }
    /deep/.ant-table-pagination.ant-pagination {
      margin: 0.35rem auto 0.5rem;
      float: none;
      display: flex;
      justify-content: center;
    }
  }
}

/deep/.ant-table-thead > tr:first-child > th {
  background: #65b3ec;
  font-size: 16px;
  height: 56px;
  text-align: center;
  color: #fff;
  font-weight: 100;
  // border-left: 2px solid #fff;
}
/deep/.ant-table-tbody > tr > td {
  text-align: center;
  color: #474747;
  a {
    color: #474747;
  }
}

.partThree {
  .x-container {
    border: 1px solid rgb(46, 102, 151);
    height: 670px;
    box-sizing: border-box;
    min-height: 1.25px;
    .xa {
      height: auto;
      margin-top: 110px;
    }
    .xa div {
      box-sizing: border-box;
      width: 25%;
      height: 224px;
      float: left;
      background-size: 100% 100%;
    }
    .xa .yt {
      background: #fff;
      border-bottom: 5px solid #86c1f2;
      text-align: center;
    }
    .xa .yt .im1 {
      margin-top: 42px;
    }
    .xa .yt .im1:hover {
      animation: rot 0.5s;
      -webkit-animation: rot 0.5s;
    }
    .xa .yt img {
      margin-top: 16px;
      margin-bottom: 10px;
      border: 0;
      outline: 0;
      vertical-align: middle;
      display: initial;
    }
    .xa a {
      text-decoration: none;
      color: inherit;
    }
    .xa .yt span {
      font-size: 18px;
    }
  }
}

// 支付蒙层
.wemsk {
  background: url(../images/mask50.png);
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 9998;
  left: 0;
  top: 0;
  display: block;
}
.ewmboxfix {
  // -webkit-box-shadow: 0px 1px 20px 0px #f5f5f5;
  // box-shadow: 0px 1px 20px 0px #f5f5f5;
  width: 50%;
  // height: 50%;
  overflow: hidden;
  border-radius: 5px;
  position: fixed;
  z-index: 999;
  left: 50%;
  top: 20%;
  margin-left: -25%;
  // margin-top: -25%;
  background: #fff;
  border: 5px solid #fff;
  display: block;
  padding: 20px;
  .closeBtn {
    text-align: right;
    margin-bottom: 20px;
  }
  .payInfo {
    margin-bottom: 10px;
    .left {
      .main {
        font-size: 0.18rem;
        color: #222222;
        font-weight: 400;
      }
      .txt {
        margin-top: 0.18rem;
        font-size: 0.16rem;
        color: #999999;
        font-weight: 400;
      }
    }
    .right {
      display: flex;
      align-items: center;
      .payable {
        font-size: 0.2rem;
        color: #333333;
        font-weight: 400;
      }
      .money {
        font-size: 0.26rem;
        color: #f29e0c;
        font-weight: 400;
      }
    }
  }
  .qrcodeBox {
    width: 145px;
    margin: 0 auto 10px;
  }
  .tipInfo {
    font-size: 0.18rem;
    margin-bottom: 10px;
  }
  .detail {
    width: 3.2rem;
    margin: 0 auto;
    margin-top: 0.3rem;
    background: rgba(249, 62, 62, 0.1);
    border: 1px solid #f93e3e;
    border-radius: 4px;
    padding: 0.09rem 0.24rem;
    font-size: 0.16rem;
    color: #675858;
    line-height: 0.24rem;
    font-weight: 400;
  }
  .successContent {
    margin-bottom: 20px;
    text-align: center;
    font-size: 20px;
  }
  .successMoney {
    font-size: 30px;
    text-align: center;
    margin-bottom: 20px;
  }
  .closeInfo {
    text-align: center;
    font-size: 0.16rem;
    color: #675858;
  }
}

.paySucess {
  top: 30%;
}

// 支付弹框
.pay-model-box {
  position: fixed;
  top: 50%;
  left: 50%;
  margin-top: -288px;
  margin-left: -331px;
  width: 662px;
  height: 576px;
  z-index: 9999;
  background-color: #fff;
  border-radius: 4px;
  .pay-main-box {
    .title {
      width: 100%;
      height: 120px;
      background-color: #f8f9ff;
      .top-title {
        padding-top: 20px;
        text-align: center;
        font-size: 18px;
        position: relative;
        font-weight: bold;
        .close-span {
          position: absolute;
          right: 20px;
          top: 0px;
          color: #999;
          font-size: 30px;
          font-weight: normal;
        }
      }
      .two-box {
        margin: 10px 0;
        text-align: center;
        font-size: 12px;
        span {
          font-weight: bold;
        }
      }
      .three-box {
        text-align: center;
        span {
          font-weight: bold;
        }
      }
    }
    .pay-money {
      text-align: center;
      font-weight: bold;
      font-size: 14px;
      span {
        color: #ff4d4f;
        font-size: 24px;
      }
    }
    .img-box {
      margin-top: 20px;
      box-sizing: border-box;
      padding: 0 80px;
      display: flex;
      justify-content: space-between;
      .left-img-box {
        border: 1px solid #ddd;
        .qrcode-out-box {
          padding: 20px;
          .qrcode-box {
            width: 183px;
            height: 183px;
          }
        }
        .bottom-remind-box {
          box-sizing: border-box;
          // margin-top: 12px;
          padding-top: 8px;
          padding-left: 20px;
          border-top: 1px solid #ddd;
          &::after {
            clear: both;
            display: block;
            content: '';
            overflow: hidden;
          }
          .img {
            float: left;
          }
          .txt {
            margin-left: 20px;
            float: left;
            font-size: 12px;
          }
        }
      }
      .right-img-box {
        img {
          width: 210px;
          height: 288px;
        }
      }
    }
    .red-txt-box {
      margin-top: 20px;
      padding: 0 80px;
      .content-red-box {
        background-color: #fff1f0;
        border: 1px solid #ffa39e;
        padding-left: 24px;
        height: 40px;
        line-height: 40px;
        img {
          margin-right: 8px;
          display: inline;
        }
      }
    }
  }
}
// 支付成功弹框
.pay-success-model-box {
  position: fixed;
  top: 50%;
  left: 50%;
  margin-top: -130px;
  margin-left: -331px;
  width: 662px;
  height: 260px;
  z-index: 9999;
  background-color: #fff;
  border-radius: 4px;
  .top-title {
    margin-top: 20px;
    text-align: center;
    font-size: 18px;
    position: relative;
    font-weight: bold;
    .close-span {
      position: absolute;
      right: 20px;
      top: -16px;
      color: #999;
      font-size: 30px;
      font-weight: normal;
    }
  }
  .middle-box {
    margin: 60px 0;
    text-align: center;
    font-size: 18px;
    font-weight: bold;
    img {
      width: 50px;
      height: 50px;
      display: inline;
      margin-right: 20px;
    }
    span {
      color: #ff7f81;
    }
  }
  .bottom-box {
    text-align: center;
    font-size: 12px;
    color: #404555;
  }
}

// 手机支付弹框
.has-pay-success {
  position: fixed;
  width: 4rem;
  height: 2.5rem;
  z-index: 9999;
  top: 30%;
  left: 20%;
  background-color: #fff;
  border-radius: 6px;
  .gth-box {
    margin-top: 0.2rem;
    text-align: center;
    .gth {
      display: inline-block;
      width: 0.5rem;
      height: 0.5rem;
      border-radius: 50%;
      border: 1px solid red;
      color: red;
    }
  }
  .txt {
    margin: 10px 0;
    text-align: center;
  }
  .btn-box {
    display: flex;
    justify-content: space-between;
    padding: 0 0.2rem;
    p {
      border: 1px solid #ddd;
      padding: 0.1rem 0.2rem;
      border-radius: 0.5rem;
    }
    .red-btn {
      background-color: red;
      border-color: red;
      color: #fff;
    }
  }
}

.m-screen-pc {
  .partTwo {
  }

  .partThree {
  }
}

.m-screen-mobile {
  .partOne {
    .bgc {
      height: 5rem;
      .img-1 {
        height: 5rem;
        .big {
          height: 1rem;
          .x-wrap {
            width: auto;
            padding: 0 0.25rem;
            .igtl {
              width: 80% !important;
              display: inline-block;
              height: 1rem;
              float: none !important;
              .lm {
                width: 0.6rem;
                height: 0.6rem;
                margin-top: 0.19rem;
                margin-right: 14px;
                line-height: 0.6rem;
                position: absolute;
                top: 0;
                left: 0;
                img {
                  width: 0.3rem;
                  height: 0.3rem;
                  margin-top: 8px;
                  margin-left: 8px;
                }
              }
              .ls {
                padding-top: 0.2rem;
                width: 90%;
                height: 1rem;
                margin-left: 10%;
                span {
                  font-size: 0.25rem;
                  color: #fff;
                  width: 100%;
                  box-sizing: border-box;
                  margin-left: 0;
                  margin-top: 30px;
                  height: 0.5rem;
                  line-height: 0.5rem;
                  display: block;
                  margin-top: 0px;
                }
              }
            }
            .igtr {
              width: 20%;
              .tc,
              .xg {
                font-size: 0.25rem !important;
                display: block;
                width: 100%;
                height: 0.4rem;
                border-radius: 0.2rem;
                border: 1px solid #fff;
                text-align: center;
                line-height: 0.4rem;
                font-size: 0.1rem;
                margin-left: 0;
                margin-top: 0.08rem;
              }
            }

            .igt2 {
              margin-top: 5px !important;
              .igt2t {
                height: 1rem;
                padding-left: 1.5rem;
                span {
                  font-size: 0.4rem;
                  height: 0.4rem !important;
                  line-height: 0.4rem;
                  padding-left: 0.4rem;
                  margin-top: 0.3rem;
                }
              }
              .igt2b {
                width: 104%;
                margin-left: -2%;
                input {
                  width: 49%;
                  font-size: 0.25rem !important;
                  margin-bottom: 10px;
                  margin-left: 1%;
                  box-sizing: border-box;
                  margin-right: 0;
                  height: 0.55rem;
                  line-height: 0.55rem;
                  border-radius: 0.275rem;
                  background: none;
                }
              }
            }
          }
        }
      }
    }
  }

  .partTwo {
    padding: 0.8rem 0.25rem;
    width: auto;
    .tit {
      text-align: center;
      font-size: 0.4rem;
      padding-bottom: 0.4rem;
      span {
        line-height: 1;
        height: auto;
      }
      .s1-1 {
        float: none;
        margin: 0 0.1rem 0.2rem;
        background-size: 0.4rem;
      }
      .s11,
      .s12 {
        float: left;
        display: block;
        width: 40%;
        margin-left: 6%;
        height: 0.7rem;
        border-radius: 0.35rem;
        line-height: 0.7rem !important;
        font-size: 0.28rem;
        background-position: 10px;
        padding-left: 0 !important;
        margin-bottom: 0.2rem;
        display: inherit;
      }

      .s3 {
        font-size: 0.24rem;
        padding-top: 0.35rem;
        float: none;
      }
      .s31 {
        display: none !important;
        position: absolute;
        bottom: 0px;
        left: 10%;
        z-index: 3;
        display: block;
        width: 80% !important;
        margin-right: 10%;
        height: 0.7rem;
        text-align: center;
        line-height: 0.7rem !important;
        border-radius: 0.35rem;
        color: #fff !important;
        padding: 0 !important;
        margin-top: 5px;
        font-size: 0.28rem !important;
      }
      .box {
        float: none;
        margin-right: 0;
        width: 100%;
        text-align: center;
        font-size: 0;
        .s1-1 {
          float: none;
          margin: 0 0.1rem;
          width: 45%;
          text-indent: 10px;
        }
      }
    }

    .mobileTable {
      padding-top: 0.4rem;
      .tableData {
        margin-bottom: 0.2rem;
        .item {
          border-top: 1px solid #ddd;
          display: flex;
          justify-content: center;
          font-size: 0.28rem;
          padding: 0.2rem 0;
          .left {
            width: 30%;
            text-align: right;
          }
          .right {
            width: 70%;

            padding-left: 0.1rem;
            .blue {
              color: #3984e1;
            }
            .red {
              color: #de4747;
            }
          }
        }
        .item:last-child {
          border-bottom: 1px solid #ddd;
        }
      }
      .more {
        padding: 0.4rem 0;
        display: flex;
        justify-content: center;
        .btn {
          font-size: 0.28rem;
          display: inline-block;
          vertical-align: top;
          border: 1px solid;
          border-radius: 1rem;
          padding: 0.1rem 0.3rem;
        }
      }
    }
  }

  .partThree {
    min-width: 320px;
    padding: 0 0.25rem;
    .co {
      height: auto !important;
      background: no-repeat;
      background-size: 100% 100%;
      .xa {
        height: auto;
        margin-top: 25px;
        overflow: hidden;
        div {
          box-sizing: border-box;
          width: 90%;
          height: 5rem;
          margin-left: 5%;
          float: none;
          background-size: 100% 100%;
          margin-bottom: 0.5rem;
        }
        .im-g {
          display: none !important;
          border: 1px solid red;
        }

        .yt {
          background: #fff;
          border-bottom: 5px solid #86c1f2;
          text-align: center;
          margin-top: 0.5rem;
          .im1 {
            margin-top: 0.84rem;
            width: 2rem;
            height: 2rem;
          }
          img {
            margin-top: 0.32rem;
            margin-bottom: 0.2rem;
          }
          span {
            font-size: 0.36rem;
          }
        }
      }
      .x-wrap {
        width: auto;
      }
    }
  }

  // 手机端支付成功弹框
  .pay-success-model-box {
    padding: 0 20px;
    position: fixed;
    top: 50%;
    left: 50%;
    margin-top: -130px;
    margin-left: -331px;
    width: 80%;
    height: 260px;
    z-index: 9999;
    background-color: #fff;
    border-radius: 4px;
    .top-title {
      margin-top: 20px;
      text-align: center;
      font-size: 18px;
      position: relative;
      font-weight: bold;
      .close-span {
        position: absolute;
        right: 20px;
        top: -16px;
        color: #999;
        font-size: 30px;
        font-weight: normal;
      }
    }
    .middle-box {
      margin: 60px 0;
      text-align: center;
      font-size: 18px;
      font-weight: bold;
      img {
        width: 50px;
        height: 50px;
        display: inline;
        margin-right: 20px;
      }
      span {
        color: #ff7f81;
      }
    }
    .bottom-box {
      text-align: center;
      font-size: 12px;
      color: #404555;
    }
  }
}
</style>
